/* eslint-disable react/no-unescaped-entities */
import React from 'react'
import Layout from '../../components/BridgePage/Layout'
import './index.scss'

const AboutPpX = () => (
  <Layout>
    <div className='about3rd'>
      <h1 className='ppTitle'>List of Third-Party SDK</h1>

      <p>
        <strong>Effective Date:</strong> May 15, 2026
      </p>

      <h2>General Statement</h2>
      <p>
        In the course of delivering services to users, Yaaro integrates various third-party SDK (Software Development Kit) technologies. When you interact with third-party websites or use applications developed by external parties, those entities may deploy their own cookies or employ other technical tools. Such technologies operate independently of our systems and are not covered by this policy.
      </p>
      <p>
        To protect your information security, we strongly recommend that you review the privacy policies of any third-party SDK before using their services. If you identify any potential risks associated with these SDKs or similar tools, you should discontinue the related activities immediately and contact us for further assistance.
      </p>
      <p>
        As we continuously improve our services, enhance stability, refine quality, and introduce new features, we may adjust the third-party SDKs we use and periodically update this list. In strict compliance with applicable laws, regulations, and supervisory requirements, we evaluate the legality, legitimacy, and necessity of any third-party SDK's processing of personal information before integrating it, thereby safeguarding your data. Detailed information regarding data usage and protection practices of third parties can be found via the links provided in each SDK entry. Please note that third-party SDKs may change their personal information handling practices due to version updates, policy modifications, or other factors. Always refer to their official documentation for the most accurate and up-to-date details.
      </p>

      <p>
        The following is a complete listing of all third-party SDKs currently implemented:
      </p>

      <h3>1. "Shengwang" SDK</h3>
      <p>
        <strong>Service Provider:</strong> Shanghai Zhaoyan Network Technology Co., Ltd.
      </p>
      <p>
        <strong>Purpose of Use:</strong> Enables audio and video communication features.
      </p>
      <p>
        <strong>Usage Scenario:</strong> Activated when users engage in voice or video messaging, live audio rooms, or similar real-time communication functions.
      </p>
      <p>
        <strong>Integration Method:</strong> The Yaaro application initialises the SDK, which then calls the system's APIs through its own logic.
      </p>
      <p><strong>Types of Personal Information Collected:</strong></p>
      <ul>
        <li>
          <strong>Device Information:</strong> Device type, model, CPU data, battery status, operating system details.
        </li>
        <li>
          <strong>Network Information:</strong> IP address, network type.
        </li>
        <li>
          <strong>Identifiers:</strong> Device identifiers, MAC address, WLAN access points, sender/receiver user IDs.
        </li>
        <li>
          <strong>User Data:</strong> User attributes, channel information, usage duration, in-channel settings, logs, and transmitted content (text, audio, or other media).
        </li>
      </ul>
      <p>
        <strong>Platform:</strong> Android
      </p>
      <p>
        <strong>Privacy Policy / Official Website:</strong> <a href='https://www.shengwang.cn/privacy-policy/' target='_blank' rel='noopener noreferrer'>
          Shengwang Privacy Policy
        </a>
      </p>

      <h3>2. Google Pay SDK</h3>
      <p>
        <strong>Service Provider:</strong> Google LLC
      </p>
      <p>
        <strong>Purpose of Use:</strong> Provides a payment processing solution via Google Pay.
      </p>
      <p>
        <strong>Usage Scenario:</strong> Used as a payment option and also as a third-party login method on the authentication page.
      </p>
      <p>
        <strong>Integration Method:</strong> The Yaaro application initialises the SDK, which then calls the system's APIs through its own logic.
      </p>
      <p>
        <strong>Types of Personal Information Collected:</strong> None
      </p>
      <p>
        <strong>Platform:</strong> Android
      </p>
      <p>
        <strong>Privacy Policy / Official Website:</strong> <a href='https://developer.android.google.cn/google/play/billing' target='_blank' rel='noopener noreferrer'>
          Google Play Billing Privacy Policy
        </a>
      </p>

      <h3>3. "Tencent Cloud IM" SDK</h3>
      <p>
        <strong>Service Provider:</strong> Tencent Cloud International Pte. Ltd.
      </p>
      <p>
        <strong>Purpose of Use:</strong> Enables instant messaging capabilities.
      </p>
      <p>
        <strong>Usage Scenario:</strong> Activated when users send text messages, images, or other types of content within the platform.
      </p>
      <p>
        <strong>Integration Method:</strong> The Yaaro application initialises the SDK, which then calls the system's APIs through its own logic.
      </p>
      <p><strong>Types of Personal Information Collected:</strong></p>
      <ul>
        <li>
          <strong>Device Information:</strong> Device type, model, CPU data, battery status, operating system details.
        </li>
        <li>
          <strong>Network Information:</strong> IP address, network type.
        </li>
        <li>
          <strong>Identifiers:</strong> Device identifiers, WLAN access points, sender/receiver user IDs.
        </li>
        <li>
          <strong>User Data:</strong> User attributes, usage duration, logs, and transmitted content (text, images, or other media).
        </li>
      </ul>
      <p>
        <strong>Platform:</strong> Android
      </p>
      <p><strong>Privacy Policy / Official Website:</strong> <a href="https://www.tencentcloud.com/?lang=en&pg=" target="_blank" rel="noopener noreferrer">Tencent Cloud IM Privacy Policy</a></p>
    </div>
  </Layout>
)

export default AboutPpX
